import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import axios from "axios";
import {
  Button,
  ButtonGroup,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  Row,
  Col,
} from "reactstrap";
import Header from "../../../layout/Header/Header";
import Swal from "sweetalert2";
import moment from "moment";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import { puede } from "../../../../permisos/permisos";

function ListadoProduccion() {
  const { user } = useContext(AuthContext);
  const URL_PRODUCCION = process.env.REACT_APP_URL_PRODUCCION;
  const URL_MAQUINAS = process.env.REACT_APP_URL_MAQUINAS;
  const URL_MOLDES = process.env.REACT_APP_URL_MOLDES_INYECCION;
  const URL_TURNOS = process.env.REACT_APP_URL_TURNOS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const headers = { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } };

  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 60);
  let fin = new Date();
  fin.setDate(fin.getDate() + 1);
  let endDate = moment(fin).format("YYYY-MM-DD");
  let startDate = moment(inicio).format("YYYY-MM-DD");

  const [maquinas, setMaquinas] = useState([]);
  const [moldes, setMoldes] = useState([]);
  const [turnos, setTurnos] = useState([]);
  const [articulos, setArticulos] = useState([]);
  const [colaboradores, setColaboradores] = useState([]);
  const [soloFueraRango, setSoloFueraRango] = useState(false);

  // Filtros
  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);
  const [filtroMaquina, setFiltroMaquina] = useState("");
  const [filtroMolde, setFiltroMolde] = useState("");
  const [filtroArticulo, setFiltroArticulo] = useState("");
  const [filtroTurno, setFiltroTurno] = useState("");
  const [filtroEstado, setFiltroEstado] = useState("");

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });
  const ITEMS_PER_PAGE = 50;

  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  const [fecha, setFecha] = useState(new Date().toISOString().split("T")[0]);
  const [ordenesAbiertas, setOrdenesAbiertas] = useState([]);
  const [ordenProduccion, setOrdenProduccion] = useState("");
  const [maquina, setMaquina] = useState("");
  const [moldeInyeccion, setMoldeInyeccion] = useState("");
  const [articulo, setArticulo] = useState("");
  const [color, setColor] = useState("");
  const [coloresCat, setColoresCat] = useState([]);
  const [turno, setTurno] = useState("");
  const [supervisor, setSupervisor] = useState("");
  const [horas, setHoras] = useState(0);
  const [primeras, setPrimeras] = useState(0);
  const [segundas, setSegundas] = useState(0);
  const [mermas, setMermas] = useState(0);
  const [observaciones, setObservaciones] = useState("");

  useEffect(() => {
    getProduccion();
    axios.get(URL_MAQUINAS, headers).then((r) => setMaquinas(r.data)).catch((e) => console.log(e));
    axios.get(URL_MOLDES, headers).then((r) => setMoldes(r.data)).catch((e) => console.log(e));
    axios.get(URL_TURNOS, headers).then((r) => setTurnos(r.data)).catch((e) => console.log(e));
    axios.get(URL_ARTICULOS, headers).then((r) => setArticulos(r.data)).catch((e) => console.log(e));
    axios.get(URL_COLABORADORES, headers).then((r) => setColaboradores(r.data)).catch((e) => console.log(e));
    axios.get(`${process.env.REACT_APP_URL_ORDENES_PRODUCCION}Abiertas`, headers).then((r) => setOrdenesAbiertas(r.data || [])).catch((e) => console.log(e));
    axios.get(process.env.REACT_APP_URL_COLORES, headers).then((r) => setColoresCat(r.data)).catch((e) => console.log(e));
  }, []);

  function getProduccion() {
    axios
      .get(URL_PRODUCCION, headers)
      .then((r) => {
        const arr = (r.data || []).map((p) => ({
          _id: p._id,
          folio: p.idProduccion,
          fecha: p.fecha,
          maquina: p.maquina ? p.maquina.nombre : "-",
          idMaquina: p.maquina ? p.maquina._id : "",
          molde: p.moldeInyeccion ? p.moldeInyeccion.nombre : "-",
          idMolde: p.moldeInyeccion ? p.moldeInyeccion._id : "",
          articulo: p.articulo ? p.articulo.descripcion : "-",
          idArticulo: p.articulo ? p.articulo._id : "",
          color: p.color ? p.color.name : "-",
          idColor: p.color ? p.color._id : "",
          turno: p.turno ? p.turno.nombre : "-",
          idTurno: p.turno ? p.turno._id : "",
          horas: p.horas,
          primeras: p.cantidad_primeras,
          segundas: p.cantidad_segundas,
          mermas: p.mermas,
          total: p.total_capturado,
          teorico: p.teorico,
          variacion: p.variacion,
          estado: p.estado,
          raw: p,
        }));
        setComments(arr);
      })
      .catch((e) => console.log(e));
  }

  // Botellas de fabricacion (molde de soplado).
  const articulosFab = articulos.filter((a) => (a.tipo_articulo || "Fabricacion") === "Fabricacion");

  function abreNuevo() {
    setFecha(new Date().toISOString().split("T")[0]);
    setOrdenProduccion("");
    setMaquina(""); setMoldeInyeccion(""); setArticulo(""); setColor(""); setTurno(""); setSupervisor("");
    setHoras(0); setPrimeras(0); setSegundas(0); setMermas(0); setObservaciones("");
    toggle();
  }

  // Al elegir orden de produccion, jala articulo/molde/maquina de la orden.
  function cambiaOrden(id) {
    setOrdenProduccion(id);
    const orden = ordenesAbiertas.find((o) => o._id === id);
    if (orden) {
      if (orden.articulo) setArticulo(orden.articulo._id || orden.articulo);
      if (orden.color) setColor(orden.color._id || orden.color);
      if (orden.maquina) setMaquina(orden.maquina._id || orden.maquina);
      if (orden.moldeInyeccion) setMoldeInyeccion(orden.moldeInyeccion._id || orden.moldeInyeccion);
    }
  }

  // Moldes compatibles con la máquina seleccionada (si no hay máquina, todos).
  const moldesCompatibles = maquina
    ? moldes.filter((m) => (m.maquinas || []).some((mq) => (mq._id || mq) === maquina))
    : moldes;

  // Al cambiar de máquina, limpia el molde si dejó de ser compatible.
  function cambiaMaquina(id) {
    setMaquina(id);
    if (moldeInyeccion) {
      const molde = moldes.find((m) => m._id === moldeInyeccion);
      const compatible = !id || (molde && (molde.maquinas || []).some((mq) => (mq._id || mq) === id));
      if (!compatible) setMoldeInyeccion("");
    }
  }

  // Teorico estimado en vivo (mismo cálculo que el back).
  const moldeSel = moldes.find((m) => m._id === moldeInyeccion);
  const teoricoVivo = moldeSel && moldeSel.ciclo > 0
    ? Math.floor((Number(horas) * 3600) / moldeSel.ciclo) * (moldeSel.cavidades || 1)
    : 0;
  const totalVivo = Number(primeras) + Number(segundas) + Number(mermas);
  const varVivo = teoricoVivo > 0 ? (((totalVivo - teoricoVivo) / teoricoVivo) * 100).toFixed(1) : 0;

  function guardar() {
    const body = {
      fecha, maquina, moldeInyeccion, articulo, color: color || null, turno, supervisor,
      ordenProduccion: ordenProduccion || null,
      horas: Number(horas), cantidad_primeras: Number(primeras),
      cantidad_segundas: Number(segundas), mermas: Number(mermas), observaciones,
    };
    axios.post(URL_PRODUCCION, body, headers)
      .then(() => {
        axios.post(URL_LOGS, { tipo: "Registrar Produccion", detalle: `Art ${articulo}`, user: user.id }, headers);
        toggle();
        Swal.fire("Good job!", "Producción registrada", "success");
        window.location.reload();
      })
      .catch((error) => Swal.fire({ icon: "error", title: "Oops...", text: "Something went wrong!", footer: `${error.response ? JSON.stringify(error.response.data) : error}` }));
  }

  // Validacion de calidad: puede corregir primeras / segundas / mermas antes de pasar a inventario.
  const [calidad, setCalidad] = useState(null);
  const [validando, setValidando] = useState(false);

  function validarCalidad(p) {
    setCalidad({
      p,
      cantidad_primeras: p.cantidad_primeras || 0,
      cantidad_segundas: p.cantidad_segundas || 0,
      mermas: p.mermas || 0,
      observacionesCalidad: "",
    });
  }
  const setCal = (campo, valor) => setCalidad((prev) => ({ ...prev, [campo]: valor }));

  function confirmaCalidad() {
    const { p } = calidad;
    setValidando(true);
    axios
      .patch(
        `${URL_PRODUCCION}Validar/${p._id}`,
        {
          fecha: new Date().toISOString().split("T")[0],
          cantidad_primeras: Number(calidad.cantidad_primeras) || 0,
          cantidad_segundas: Number(calidad.cantidad_segundas) || 0,
          mermas: Number(calidad.mermas) || 0,
          observacionesCalidad: calidad.observacionesCalidad || "",
        },
        headers
      )
      .then(() => {
        const cambio =
          Number(calidad.cantidad_primeras) !== Number(p.cantidad_primeras || 0) ||
          Number(calidad.cantidad_segundas) !== Number(p.cantidad_segundas || 0) ||
          Number(calidad.mermas) !== Number(p.mermas || 0);
        axios.post(
          URL_LOGS,
          {
            tipo: "Validar Produccion Calidad",
            detalle: `Prod ${p.idProduccion}${cambio ? ` (corregida: ${calidad.cantidad_primeras}/${calidad.cantidad_segundas}/${calidad.mermas})` : ""}`,
            user: user.id,
          },
          headers
        );
        setValidando(false);
        setCalidad(null);
        Swal.fire("Listo!", "Producción validada", "success");
        window.location.reload();
      })
      .catch((error) => {
        setValidando(false);
        Swal.fire({ icon: "error", title: "Oops...", text: error.response?.data?.message || "Something went wrong!" });
      });
  }

  const badgeVar = (v, teorico) => {
    if (!teorico) return <span className="badge badge-secondary">s/teórico</span>;
    const fuera = Math.abs(v) > 5;
    return (
      <span className={`badge badge-${fuera ? "danger" : "success"}`}>
        {v > 0 ? "+" : ""}{v}%
      </span>
    );
  };

  const tableHeaders = [
    { name: "Folio", field: "folio", sortable: true },
    { name: "Fecha", field: "fecha", sortable: true },
    { name: "Máquina", field: "maquina", sortable: true },
    { name: "Molde Iny.", field: "molde", sortable: true },
    { name: "Artículo", field: "articulo", sortable: true },
    { name: "Color", field: "color", sortable: true },
    { name: "Turno", field: "turno", sortable: false },
    { name: "Horas", field: "horas", sortable: false },
    { name: "1ras / 2das / Merma", field: "primeras", sortable: false },
    { name: "% 1ras", field: "pctPrimeras", sortable: false },
    { name: "% 2das", field: "pctSegundas", sortable: false },
    { name: "% Merma", field: "pctMermas", sortable: false },
    { name: "Total", field: "total", sortable: true },
    { name: "Teórico", field: "teorico", sortable: true },
    { name: "Var.", field: "variacion", sortable: true },
    { name: "Estado", field: "estado", sortable: false },
    { name: "Calidad", field: "calidad", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let cc = comments;
    if (search) {
      const s = search.toLowerCase();
      cc = cc.filter(
        (c) =>
          (c.maquina || "").toLowerCase().includes(s) ||
          (c.molde || "").toLowerCase().includes(s) ||
          (c.articulo || "").toLowerCase().includes(s) ||
          (c.turno || "").toLowerCase().includes(s) ||
          (c.estado || "").toLowerCase().includes(s) ||
          c.folio.toString().includes(search)
      );
    }
    if (selectedFechaInicio) cc = cc.filter((e) => e.fecha >= selectedFechaInicio);
    if (selectedFechaFin) cc = cc.filter((e) => e.fecha <= selectedFechaFin);
    if (filtroMaquina) cc = cc.filter((e) => e.idMaquina === filtroMaquina);
    if (filtroMolde) cc = cc.filter((e) => e.idMolde === filtroMolde);
    if (filtroArticulo) cc = cc.filter((e) => e.idArticulo === filtroArticulo);
    if (filtroTurno) cc = cc.filter((e) => e.idTurno === filtroTurno);
    if (filtroEstado) cc = cc.filter((e) => e.estado === filtroEstado);
    if (soloFueraRango) cc = cc.filter((e) => e.teorico > 0 && Math.abs(e.variacion) > 5);

    setTotalItems(cc.length);

    const numericos = ["folio", "total", "teorico", "variacion", "horas"];
    if (sorting.field && !numericos.includes(sorting.field)) {
      const rev = sorting.order === "asc" ? 1 : -1;
      cc = [...cc].sort((a, b) => rev * (a[sorting.field] || "").toString().localeCompare((b[sorting.field] || "").toString()));
    }
    if (sorting.field && numericos.includes(sorting.field)) {
      const rev = sorting.order === "asc" ? 1 : -1;
      cc = [...cc].sort((a, b) => (parseFloat(a[sorting.field] || 0) > parseFloat(b[sorting.field] || 0) ? rev : -rev));
    }
    return cc.slice((currentPage - 1) * ITEMS_PER_PAGE, currentPage * ITEMS_PER_PAGE);
  }, [comments, currentPage, search, sorting, selectedFechaInicio, selectedFechaFin, filtroMaquina, filtroMolde, filtroArticulo, filtroTurno, filtroEstado, soloFueraRango]);

  // Filas filtradas (sin paginar) para exportar.
  function filasFiltradas() {
    return comments
      .filter((e) => (!selectedFechaInicio || e.fecha >= selectedFechaInicio))
      .filter((e) => (!selectedFechaFin || e.fecha <= selectedFechaFin))
      .filter((e) => (!filtroMaquina || e.idMaquina === filtroMaquina))
      .filter((e) => (!filtroMolde || e.idMolde === filtroMolde))
      .filter((e) => (!filtroArticulo || e.idArticulo === filtroArticulo))
      .filter((e) => (!filtroTurno || e.idTurno === filtroTurno))
      .filter((e) => (!filtroEstado || e.estado === filtroEstado))
      .filter((e) => (!soloFueraRango || (e.teorico > 0 && Math.abs(e.variacion) > 5)));
  }

  // Porcentaje sobre el total capturado (primeras + segundas + mermas).
  function pct(parte, total) {
    if (!total || total <= 0) return "0%";
    return `${((parte / total) * 100).toFixed(1)}%`;
  }

  function PDFTabla() {
    const body = filasFiltradas().map((c) => [
      c.folio, c.fecha, c.maquina, c.molde, c.articulo, c.color, c.turno, c.horas,
      `${c.primeras} / ${c.segundas} / ${c.mermas}`,
      pct(c.primeras, c.total), pct(c.segundas, c.total), pct(c.mermas, c.total),
      c.total, c.teorico,
      `${c.variacion > 0 ? "+" : ""}${c.variacion}%`, c.estado,
    ]);
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 240, 10, 45, 15);
    doc.text("Producción", 14, 18);
    doc.setFontSize(11);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 14, 25);
    doc.autoTable({
      head: [["Folio", "Fecha", "Máquina", "Molde", "Artículo", "Color", "Turno", "Horas", "1ras/2das/Merma", "% 1ras", "% 2das", "% Merma", "Total", "Teórico", "Var.", "Estado"]],
      body,
      startY: 30,
      styles: { fontSize: 8 },
    });
    window.open(doc.output("bloburl"), "_blank");
  }

  function excel() {
    const data = filasFiltradas().map((c) => ({
      Folio: c.folio, Fecha: c.fecha, Maquina: c.maquina, Molde: c.molde,
      Articulo: c.articulo, Color: c.color, Turno: c.turno, Horas: c.horas,
      Primeras: c.primeras, Segundas: c.segundas, Merma: c.mermas,
      PorcPrimeras: pct(c.primeras, c.total), PorcSegundas: pct(c.segundas, c.total), PorcMerma: pct(c.mermas, c.total),
      Total: c.total, Teorico: c.teorico, Variacion: c.variacion, Estado: c.estado,
    }));
    new ExportJsonExcel({
      fileName: "Produccion",
      datas: [{ sheetData: data, sheetName: "Produccion" }],
    }).saveExcel();
  }

  return (
    <>
      <Header />
      <br />
      <div className="container">
        {puede(user, "produccion.produccion.ver") ? (
          <div className="card col-12">
            <div className="page-header">
              <div>
                <h3 className="page-title">
                  <i className="fas fa-cogs" style={{ marginRight: 8, color: "#10b981" }} />
                  Producción
                </h3>
                <p className="page-subtitle">Registro de corridas (no ligado a pedidos)</p>
              </div>
              <div className="page-actions">
                {puede(user, "produccion.produccion.crear") && (
<Button size="sm" color="success" onClick={abreNuevo} style={{ marginRight: 8 }}>
                  <i className="fas fa-plus" style={{ marginRight: 6 }} /> Nueva Producción
                </Button>
)}
                <ButtonGroup id="logoutBoton">
                  <Button size="sm" className="btn" color="danger" onClick={PDFTabla}>
                    PDF <i className="far fa-file-pdf"></i>
                  </Button>
                  <Button size="sm" className="btn" color="primary" onClick={excel}>
                    Excel <i className="far fa-file-excel"></i>
                  </Button>
                </ButtonGroup>
              </div>
            </div>

            <div className="row">
              <div className="col-md-8">
                <Pagination
                  total={totalItems}
                  itemsPerPage={ITEMS_PER_PAGE}
                  currentPage={currentPage}
                  onPageChange={(page) => setCurrentPage(page)}
                />
              </div>
              <div className="col-md-4 d-flex flex-row-reverse">
                <Search onSearch={(value) => { setSearch(value); setCurrentPage(1); }} />
              </div>
            </div>

            <Row>
              <Col md={2}>
                <Label className="mr-sm-2">Fecha Inicio</Label>
                <Input bsSize="sm" type="date" value={selectedFechaInicio} onChange={(e) => setSelectedFechaInicio(e.target.value)} />
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Fecha Fin</Label>
                <Input bsSize="sm" type="date" value={selectedFechaFin} onChange={(e) => setSelectedFechaFin(e.target.value)} />
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Máquina</Label>
                <Input bsSize="sm" type="select" value={filtroMaquina} onChange={(e) => { setFiltroMaquina(e.target.value); setCurrentPage(1); }}>
                  <option value="">Todas</option>
                  {maquinas.map((m) => <option key={m._id} value={m._id}>{m.nombre}</option>)}
                </Input>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Molde</Label>
                <Input bsSize="sm" type="select" value={filtroMolde} onChange={(e) => { setFiltroMolde(e.target.value); setCurrentPage(1); }}>
                  <option value="">Todos</option>
                  {moldes.map((m) => <option key={m._id} value={m._id}>{m.nombre}</option>)}
                </Input>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Artículo</Label>
                <Input bsSize="sm" type="select" value={filtroArticulo} onChange={(e) => { setFiltroArticulo(e.target.value); setCurrentPage(1); }}>
                  <option value="">Todos</option>
                  {articulosFab.map((a) => <option key={a._id} value={a._id}>{a.descripcion}</option>)}
                </Input>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Estado</Label>
                <Input bsSize="sm" type="select" value={filtroEstado} onChange={(e) => { setFiltroEstado(e.target.value); setCurrentPage(1); }}>
                  <option value="">Todos</option>
                  <option value="Capturada">Capturada</option>
                  <option value="Validada">Validada</option>
                </Input>
              </Col>
            </Row>
            <div style={{ display: "flex", alignItems: "center", gap: 8, margin: "4px 0 12px" }}>
              <input
                type="checkbox"
                id="soloFueraRango"
                checked={soloFueraRango}
                onChange={(e) => setSoloFueraRango(e.target.checked)}
                style={{ width: 16, height: 16, margin: 0, cursor: "pointer" }}
              />
              <label htmlFor="soloFueraRango" style={{ margin: 0, fontSize: "0.85rem", cursor: "pointer" }}>
                Solo fuera de ±5%
              </label>
            </div>
            <Table size="sm" striped borderless className="table-responsive-xl table-dark-header">
              <TableHeader headers={tableHeaders} onSorting={(field, order) => setSorting({ field, order })} />
              <tbody>
                {commentsData.map((p) => (
                  <tr key={p._id}>
                    <td>{p.folio}</td>
                    <td>{p.fecha}</td>
                    <td>{p.maquina}</td>
                    <td>{p.molde}</td>
                    <td>{p.articulo}</td>
                    <td>{p.color}</td>
                    <td>{p.turno}</td>
                    <td>{p.horas}</td>
                    <td>{p.primeras} / {p.segundas} / {p.mermas}</td>
                    <td>{pct(p.primeras, p.total)}</td>
                    <td>{pct(p.segundas, p.total)}</td>
                    <td>{pct(p.mermas, p.total)}</td>
                    <td>{p.total}</td>
                    <td>{p.teorico}</td>
                    <td>{badgeVar(p.variacion, p.teorico)}</td>
                    <td>
                      {p.estado === "Validada"
                        ? <span className="badge badge-success">Validada</span>
                        : <span className="badge badge-warning">Capturada</span>}
                    </td>
                    <td>
                      {p.estado !== "Validada" && (
                        <Button color="primary" size="sm" onClick={() => validarCalidad(p.raw)} title="Validar calidad">
                          <i className="fas fa-check-double"></i>
                        </Button>
                      )}
                    </td>
                  </tr>
                ))}
                {commentsData.length === 0 && (
                  <tr>
                    <td colSpan={13} className="text-muted" style={{ textAlign: "center" }}>
                      Sin producción en el rango / filtros.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
            <div className="col-md-6">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
          </div>
        ) : undefined}
      </div>

      <Modal size="md" isOpen={!!calidad} toggle={() => setCalidad(null)}>
        <ModalHeader toggle={() => setCalidad(null)}>Validación de calidad</ModalHeader>
        {calidad && (
          <ModalBody>
            <p style={{ marginBottom: 10 }}>
              Producción #{calidad.p.idProduccion}. Corrige las cantidades si calidad encontró diferencias; al validar se descuenta la materia prima y se suman primeras y segundas al inventario.
            </p>
            <Row>
              {[["cantidad_primeras", "Primeras"], ["cantidad_segundas", "Segundas"], ["mermas", "Mermas"]].map(([k, t]) => (
                <Col md={4} key={k}>
                  <Label>{t}</Label>
                  <Input type="number" min={0} value={calidad[k]} onChange={(e) => setCal(k, e.target.value)} />
                  {Number(calidad[k]) !== Number(calidad.p[k] || 0) && (
                    <small className="text-muted">capturado: {calidad.p[k] || 0}</small>
                  )}
                </Col>
              ))}
            </Row>
            <br />
            <Label>Observaciones de calidad</Label>
            <Input type="text" value={calidad.observacionesCalidad} onChange={(e) => setCal("observacionesCalidad", e.target.value)} />
          </ModalBody>
        )}
        <ModalFooter>
          <Button color="secondary" onClick={() => setCalidad(null)}>Cancelar</Button>
          <Button color="success" onClick={confirmaCalidad} disabled={validando}>
            <i className="fas fa-check" style={{ marginRight: 6 }} /> Validar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="lg" isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          <i className="fas fa-cogs" style={{ marginRight: 8, color: "#10b981" }} />
          Nueva Producción
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={12}>
              <Label>Orden de Producción (opcional)</Label>
              <Input type="select" value={ordenProduccion} onChange={(e) => cambiaOrden(e.target.value)}>
                <option value="">Sin orden</option>
                {ordenesAbiertas.map((o) => (
                  <option key={o._id} value={o._id}>
                    #{o.idOrdenProduccion} — {o.articulo ? o.articulo.descripcion : "-"}{o.color ? ` ${o.color.name}` : ""} (pend. {o.pendiente})
                  </option>
                ))}
              </Input>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={4}>
              <Label>Fecha</Label>
              <Input type="date" value={fecha} onChange={(e) => setFecha(e.target.value)} />
            </Col>
            <Col md={4}>
              <Label>Máquina</Label>
              <Input type="select" value={maquina} onChange={(e) => cambiaMaquina(e.target.value)}>
                <option value="">Selecciona...</option>
                {maquinas.map((m) => <option key={m._id} value={m._id}>{m.nombre}</option>)}
              </Input>
            </Col>
            <Col md={4}>
              <Label>Turno</Label>
              <Input type="select" value={turno} onChange={(e) => setTurno(e.target.value)}>
                <option value="">Selecciona...</option>
                {turnos.map((t) => <option key={t._id} value={t._id}>{t.nombre}</option>)}
              </Input>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={4}>
              <Label>Molde Inyección</Label>
              <Input type="select" value={moldeInyeccion} onChange={(e) => setMoldeInyeccion(e.target.value)}>
                <option value="">{maquina ? "Selecciona..." : "Elige máquina primero..."}</option>
                {moldesCompatibles.map((m) => <option key={m._id} value={m._id}>{m.nombre} (cav {m.cavidades}, ciclo {m.ciclo}s)</option>)}
              </Input>
              {maquina && moldesCompatibles.length === 0 && (
                <small className="text-danger">No hay moldes compatibles con esta máquina.</small>
              )}
            </Col>
            <Col md={4}>
              <Label>Artículo (botella)</Label>
              <Input type="select" value={articulo} onChange={(e) => setArticulo(e.target.value)}>
                <option value="">Selecciona...</option>
                {articulosFab.map((a) => <option key={a._id} value={a._id}>{a.descripcion}</option>)}
              </Input>
            </Col>
            <Col md={4}>
              <Label>Color</Label>
              <Input type="select" value={color} onChange={(e) => setColor(e.target.value)}>
                <option value="">Sin color</option>
                {(() => {
                  const art = articulos.find((a) => a._id === articulo);
                  const lista = (art && art.colores) || [];
                  return lista
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((c) => <option key={c._id} value={c._id}>{c.name}</option>);
                })()}
              </Input>
            </Col>
            <Col md={4}>
              <Label>Supervisor</Label>
              <Input type="select" value={supervisor} onChange={(e) => setSupervisor(e.target.value)}>
                <option value="">Selecciona...</option>
                {colaboradores.map((c) => <option key={c._id} value={c._id}>{c.nombre} {c.apellido || ""}</option>)}
              </Input>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={3}>
              <Label>Horas</Label>
              <Input type="number" value={horas} onChange={(e) => setHoras(e.target.value)} />
            </Col>
            <Col md={3}>
              <Label>Primeras</Label>
              <Input type="number" value={primeras} onChange={(e) => setPrimeras(e.target.value)} />
              <small className="text-muted">{pct(Number(primeras), totalVivo)} del total</small>
            </Col>
            <Col md={3}>
              <Label>Segundas</Label>
              <Input type="number" value={segundas} onChange={(e) => setSegundas(e.target.value)} />
              <small className="text-muted">{pct(Number(segundas), totalVivo)} del total</small>
            </Col>
            <Col md={3}>
              <Label>Mermas</Label>
              <Input type="number" value={mermas} onChange={(e) => setMermas(e.target.value)} />
              <small className="text-muted">{pct(Number(mermas), totalVivo)} del total</small>
            </Col>
          </Row>
          <br />
          {/* Comparativo en vivo */}
          <div style={{ background: "#f8fafc", borderRadius: 8, padding: "10px 14px", fontSize: "0.85rem" }}>
            <b>Comparativo:</b>{" "}
            Capturado <b>{totalVivo}</b> vs Teórico <b>{teoricoVivo}</b>{" "}
            {teoricoVivo > 0 && (
              <span style={{ color: Math.abs(varVivo) > 5 ? "#dc3545" : "#198754", fontWeight: 600 }}>
                ({varVivo > 0 ? "+" : ""}{varVivo}%)
              </span>
            )}
            {teoricoVivo === 0 && <span className="text-muted"> — selecciona molde y horas para estimar</span>}
          </div>
          <br />
          <Label>Observaciones</Label>
          <Input type="textarea" value={observaciones} onChange={(e) => setObservaciones(e.target.value)} />
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={guardar}>
            <i className="fas fa-save" style={{ marginRight: 6 }} /> Guardar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ListadoProduccion;
